<template>
    <div class="c_table_wrap">
        <table>
            <colgroup>
                <col width="200px;">
                <col width="">
            </colgroup>
            <tr>
                <td class="c_t_title">제목</td>
                <td>
                    <div>
                        {{ competitionData.c_title }}
                    </div>
                </td>
            </tr>

            <tr>
                <td class="c_t_title">상태</td>
                <td>
                    <div>
                        {{ returnStatus(competitionData.c_status) }}
                    </div>
                </td>
            </tr>

            <tr>
                <td class="c_t_title">썸네일</td>
                <td>
                    <div>
                        <img class="competition_thumb" :src="returnImage(competitionData.Poster,730,1032)"
                             @click="openImageFile(competitionData.Poster)"
                             style="cursor: pointer; width: 730px;height: 1032px"/>
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">카테고리</td>
                <td>
                    <div>
                        {{ returnCategoryName(competitionData.ic_idx) }}
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">해시태그(세카테고리)</td>
                <td>
                    <div>
                      <span v-for="(hash,index) in returnHashSelect(competitionData.Hashtag)" :key="`hash-${index}`">
                          #{{ hash }}
                      </span>
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">해시태그(직접입력)</td>
                <td>
                    <div>
                <span v-for="(hash,index) in returnHashWrote(competitionData.Hashtag)" :key="`hash-${index}`">
                          #{{ hash }}
                      </span>
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">주관</td>
                <td>
                    <div>
                        {{ competitionData.c_organize }}
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">대상</td>
                <td>
                    <div>
                        {{ competitionData.c_target }}
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">공모전 내용</td>
                <td>
                    <div v-html="replaceBr(competitionData.c_context)">
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">라이선스 이용안내</td>
                <td>
                    <div v-html="replaceBr(competitionData.c_license)">
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">평가기준</td>
                <td>
                    <div v-for=" (evaluate,index) in returnEvaluates(competitionData.Evaluates)"
                         :key="`evaluate-${index}`">
                        <p> {{ evaluate }}</p>
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">안내 첨부파일</td>
                <td>
                    <div class="hover">
                        {{ returnIntroName(competitionData.Intro) }}
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">심사위원</td>
                <td>
                    <div>
                      <span v-for="(judge,index) in competitionData.Judges" :key="`judge-${index}`"
                            @click="movePage(`/member/${judge.mb_no}`)" class="hover">
                           {{ judge.mb_nick }}
                      </span>
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">총상금</td>
                <td>
                    <div>
                        {{ returnCommas(competitionData.c_prize) }} Mg
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">응모기간</td>
                <td>
                    <div>
                        <!--                      {{competitionData.c_license}}-->
                        {{ returnDateFormat(competitionData.c_start_time, 'YYYY-MM-DD HH:mm') }} ~
                        {{ returnDateFormat(competitionData.c_end_time, 'YYYY-MM-DD HH:mm') }}
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">발표일</td>
                <td>
                    <div>
                        {{ returnDateFormat(competitionData.c_release_time, 'YYYY-MM-DD HH:mm') }}
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">1인 응모가능 수</td>
                <td>
                    <div>
                        {{ competitionData.c_apply_cnt }}
                    </div>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
import competitionValidator from "@/mixins/validators/competitionValidator";
import util from "@/mixins/util";
import imageOption from "@/mixins/imageOption";
import {categoryType} from "@/service/competitionService";
import dateMixins from "@/mixins/dateMixins";

export default {
    name: "CompetitionWriteDefaultLayout",
    mixins: [competitionValidator, imageOption, dateMixins],
    components: {},
    inject: ['competitionWriteSetData'],
    provide() {
        return {}
    },
    props: {
        competitionData: {
            type: Object,
            default: () => {
                return {}
            }
        },
    },
    data() {
        return {
            categoryType: categoryType
        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        parentChange(key, value) {
            this.competitionWriteSetData(key, value)
        },
        returnStatus(status) {
            switch (status) {
                case 0 : {
                    return '진행예정'
                }
                case 1 : {
                    return '진행중'
                }
                case 2 : {
                    return '심사중'
                }
                case 3 : {
                    return '발표완료'
                }
                default : {
                    return ''
                }
            }
        },
        returnImage(image, width = 32, height = 32) {
            if (!util.isEmpty(image)) {
                return `${image[0].org_url}?${this.setImageOptions(width * 2, height * 2, 'jpg')}`
            }
            return ''
        },
        openImageFile(poster) {
            let url = ''
            if (!util.isEmpty(poster)) {
                url = poster[0].org_url
            }
            window.open(url, '_blank');
        },
        returnHashSelect(hashtag) {
            let list = []
            util.each(hashtag, (hash, index, arr) => {
                if (!util.isEmpty(hash.ic_name) && hash.ch_type === 1) {
                    list.push(hash.ic_name)
                }
            })
            return list
        },
        returnHashWrote(hashtag) {
            let list = []
            util.each(hashtag, (hash, index, arr) => {
                if (!util.isEmpty(hash.ch_hashtag) && hash.ch_type === 2) {
                    list.push(hash.ch_hashtag)
                }
            })
            return list
        },
        returnCategoryName(value) {
            let keys = Object.keys(this.categoryType)
            let category = keys.filter(category => Number(category) === value);
            if (!util.isEmpty(this.categoryType[category])) {
                return this.categoryType[category].name
            } else {
                return ''
            }
        },
        returnEvaluates(evaluates = []) {
            let list = []
            util.each(evaluates, (evaluate, index, arr) => {
                list.push(evaluate.cs_evaluate)
            })
            return list
        },
        returnIntroName(intro) {
            return !util.isEmpty(intro) ? intro[0].org_name : ''
        },
        returnCommas(x = 0) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        movePage(url) {
            this.$router.push(url)
        },
        replaceBr(content) {
            if (util.isEmpty(content)) {
                return '';
            }
            return content.replace(/(\n|\r\n)/g, '<br>');
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
